import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import colors from 'theme/colors';
import media from 'theme/media';
import zindex from 'theme/zIndex';

import { PromoSpinnerCircle } from './PromoSpinnerCircle';
import { PromoText } from '../promo-text/PromoText';
import { PromoRow } from '../PromoRow/PromoRow';

const SpinnerOverlay = styled.div`
    bottom: 0;
    left: 0;
    min-width: 288px;
    overflow: auto;
    position: ${(props) => (props.insidePopup ? 'absolute' : 'fixed')};
    right: 0;
    top: 0;
    background-color: ${colors.whiteRgba96};
    z-index: ${zindex.spinnerOverlay};
`;
const SpinnerContainer = styled.div`
    /* content width 480 */
    max-width: 528px;
    box-sizing: border-box;
    padding: 128px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    margin: 0 auto;

    ${media.tablet720} {
        /* content width 504px */
        max-width: 552px;
    }
`;

const PromoSpinner = ({ forceShow = false, ...props }) => {
    if (props.isShowSpinner || forceShow) {
        return (
            <SpinnerOverlay insidePopup={props.insidePopup}>
                <SpinnerContainer>
                    <PromoRow indent={props.isEmptyText ? '0' : '24px'}>
                        <PromoSpinnerCircle />
                    </PromoRow>
                    {!props.isEmptyText && (props.siteSpinnerText || props.customSpinnerText) && (
                        <PromoText tag="p" variant="subheader">
                            {props.customSpinnerText ? props.customSpinnerText : props.siteSpinnerText}
                        </PromoText>
                    )}
                </SpinnerContainer>
            </SpinnerOverlay>
        );
    } else {
        return false;
    }
};

PromoSpinner.propTypes = {
    insidePopup: PropTypes.bool,
};
const mapStateToProps = (state) => {
    return {
        isShowSpinner: state.app.isShowSpinner,
        siteSpinnerText: state.extra.noAuthFooter?.messages?.siteSpinnerText,
    };
};

export default connect(mapStateToProps)(PromoSpinner);
